import type { PartnerTenant } from '@shipium-corp/shipium-ts-types';
import type { ThirdPartyBillingAccount } from '../../services/FP_FulfillmentContextService/types';
import type { HydratedThirdPartyBillingAccount, HydrationAssetError } from '../types';
import { extractTenantDetails, findScopedTenant, generateHydrationError, isActiveAsset } from './utils';
const assetType = 'thirdPartyBillingAccount';

export const hydrateThirdPartyBillingAccount = (
  tenantList: PartnerTenant[],
  thirdPartyBillingAccount: ThirdPartyBillingAccount,
): HydratedThirdPartyBillingAccount => {
  const notActive =
    !isActiveAsset(thirdPartyBillingAccount) && thirdPartyBillingAccount
      ? generateHydrationError('Not configured', assetType)
      : null;
  const notLinked = !thirdPartyBillingAccount ? generateHydrationError('Not configured', assetType) : null;
  const tenant = thirdPartyBillingAccount
    ? findScopedTenant(thirdPartyBillingAccount.thirdPartyBillingAccountId, 'thirdPartyBillingAccount', tenantList)
    : null;
  const errors: HydrationAssetError[] = [notActive, notLinked].filter((err): err is HydrationAssetError => !!err);
  return {
    ...((thirdPartyBillingAccount ?? {}) as ThirdPartyBillingAccount),
    ...(tenant ? { tenant: extractTenantDetails(tenant) } : {}),
    validationInfo: {
      errors,
      configurationValid: !errors.length,
      warnings: [],
      configurationComplete: !errors.length,
    },
  };
};
